import React from 'react'
import StepperNavigation from '../../../../components/steppernavigation/StepperNavigation';
import styles from "./AssignMemberCommon.styles"
import AssignMembersTable from './assignmemberstable/AssignMembersTable';
import AssignedMembersConfirmation from './assignedmembersconfirmation/AssignedMembersConfirmation';
import { PAYER_SECTION_ROUTES } from '../../../payerssection/constants';
import useTxNavigate from '../../../../../libs/txnavigate/TxNavigateHook';

export default function AssignMembers() {

    const navigate = useTxNavigate();

    const steps = [
        {
            title: "Assign Members",
            stepBodyComponent: <AssignMembersTable />,
            submitButtonText: "Next",
            submitCb: () => { },
        }, {
            title: "Assigned users confirmation",
            stepBodyComponent: <AssignedMembersConfirmation />,
            backButtonText: "Back",
            prevCb: () => { },
            submitButtonText: "Submit",
            submitCb: () => { navigate(`/${PAYER_SECTION_ROUTES.PAYER}/${PAYER_SECTION_ROUTES.PAYER_ADDED}`) },
        },
    ];

    return (
        <>
            <div style={styles.assignMemberContainer}>
                <AssignMembersTable/>
            </div>
        </>
    )
}